import { Colors } from 'src/components/theme'
import { OutlinedInput, Select as SelectBase, SelectProps as SelectBaseProps, MenuProps } from '@mui/material'
import { SyntheticEvent, useState } from 'react'

const MenuProps: Partial<MenuProps> = {
  PaperProps: {
    style: {
      backgroundColor: 'white',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      outline: 'none',
      boxShadow: '2px 2px 15px 0px rgba(29, 31, 48, 0.07)',
      border: `1px solid ${Colors.borderInputHover}`,
      borderTop: 0,
    },
    sx: {
      '& ul': {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
}

export const Select = <T,>({ open, children, style, onOpen, onClose, ...props }: SelectBaseProps<T>) => {
  const [internalOpen, setInternalOpen] = useState(false)

  const handleOpen = (e: SyntheticEvent<Element, Event>) => {
    setInternalOpen(true)
    onOpen?.(e)
  }

  const handleClose = (e: SyntheticEvent<Element, Event>) => {
    setInternalOpen(false)
    onClose?.(e)
  }

  return (
    <SelectBase
      {...props}
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      style={{
        height: 34,
        backgroundColor: 'white',
        outline: 'none',
        borderBottomLeftRadius: open || internalOpen ? 0 : undefined,
        borderBottomRightRadius: open || internalOpen ? 0 : undefined,
        fontWeight: 600,
        ...style,
      }}
      sx={{
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: `1px solid ${Colors.borderInputHover}`,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          border: `1px solid ${Colors.borderInputHover}`,
        },
        fieldset: {
          border: '1px solid rgba(214,223,233,255)',
        },
      }}
      input={<OutlinedInput size="small" />}
      MenuProps={{
        ...props.MenuProps,
        PaperProps: {
          ...props?.MenuProps?.PaperProps,
          style: { ...MenuProps.PaperProps?.style, ...props?.MenuProps?.PaperProps?.style },
          sx: { ...(MenuProps.PaperProps?.sx as any), ...props?.MenuProps?.PaperProps?.sx },
        },
      }}>
      {children}
    </SelectBase>
  )
}
